module.exports = __webpack_public_path__ + "static/media/humoonLogo.8578cf52.png";